import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { ViewTransitionTypes, viewTransition } from "@/utils/view-transitions";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration",
)({
	component: RouteComponent,
	beforeLoad: ({ location }) => {
		if (
			location.pathname === "/admin/configuration" ||
			location.pathname === "/admin/configuration/"
		) {
			throw redirect({
				to: "/admin/configuration/jobTypes",
				replace: true,
				...viewTransition(ViewTransitionTypes.FADE),
			});
		}
	},
});

function RouteComponent() {
	return <Outlet />;
}
